<div class="non-editable">
  <div class="row">
    <div class="col-sm-6">
      <div class="content">
        <div>
          <div>{{ 'label.ID' | translate }}:</div>
          <div>{{ jobseeker?.jobseekerId }}</div>
        </div>
        <div>
          <div>{{ 'label.Language' | translate }}:</div>
          <div [hidden]="field?.languageId?.isInEditMode">
            {{ jobseeker?.languageId | translate }}
            <button
              class="fa fa-pencil btn btn-link"
              (click)="onLanguageIdEditClick()"
              [disabled]="isInEditMode"
            ></button>
          </div>
          <div [hidden]="!field?.languageId.isInEditMode" class="edit-mode">
            <label style="margin-right: 5px">
              <input
                type="radio"
                [value]="primaryLanguage"
                name="Language"
                [(ngModel)]="jobseeker.languageId"
              />
              {{ primaryLanguage | translate }}
            </label>
            <label>
              <input
                type="radio"
                [value]="alternativeLanguage"
                name="Language"
                [(ngModel)]="jobseeker.languageId"
              />
              {{ alternativeLanguage | translate }}
            </label>
            <br />
            <button
              class="btn btn-default"
              (click)="onEditJobseekerPreferredLanguage()"
            >
              {{ 'label.Save' | translate }}
            </button>
            <button
              class="btn btn-default"
              (click)="onJobseekerPreferredLanguageEditCancelClick()"
            >
              {{ 'label.Cancel' | translate }}
            </button>
          </div>
        </div>
        <div>
          <div>{{ 'label.UserEmail' | translate }}:</div>
          <div [hidden]="field?.username?.isInEditMode">
            {{ jobseeker?.username }}
            <button
              class="fa fa-pencil btn btn-link"
              (click)="onUsernameEditClick()"
              [disabled]="isInEditMode"
            ></button>
          </div>
          <div [hidden]="!field?.username.isInEditMode" class="edit-mode">
            <input
              type="text"
              [ngModel]="jobseeker && jobseeker.username"
              (ngModelChange)="jobseeker && (jobseeker.username = $event)"
            />
            <button class="btn btn-default" (click)="onUsernameSaveClick()">
              {{ 'label.Save' | translate }}
            </button>
            <button
              class="btn btn-default"
              (click)="onUsernameEditCancelClick()"
            >
              {{ 'label.Cancel' | translate }}
            </button>
            <hr-field-state-marker
              [field]="field?.username"
            ></hr-field-state-marker>
          </div>
        </div>
        <div>
          <div>{{ 'label.PrivacyStatus' | translate }}:</div>
          <div>{{ jobseeker?.privacyName }}</div>
        </div>
        <div>
          <div>{{ 'label.ProfileState' | translate }}:</div>
          <div>{{ jobseeker?.profileStateName }}</div>
        </div>
        <div>
          <div>{{ 'label.NumberOfVacanciesAppliedTo' | translate }}:</div>
          <div>{{ jobseeker?.numberOfAppliedVacancies }}</div>
        </div>
        <div>
          <div>{{ 'label.NumberOfCvBoxesAppliedTo' | translate }}:</div>
          <div>{{ jobseeker?.numberOfAppliedCvBoxes }}</div>
        </div>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="content">
        <div>
          <div>{{ 'label.RegistrationDate' | translate }}:</div>
          <div>{{ jobseeker?.registrationDate | date : dateFormat }}</div>
        </div>
        <div>
          <div>{{ 'label.LastLoginDate' | translate }}:</div>
          <div>{{ jobseeker?.lastLoginDate | date : dateFormat }}</div>
        </div>
        <div>
          <div>{{ 'label.LastUpdateDate' | translate }}:</div>
          <div>{{ jobseeker?.lastUpdateDate | date : dateFormat }}</div>
        </div>
      </div>
    </div>
    <div class="col-sm-2">
      <div style="text-align: right">
        <div>
          <button (click)="onResetPasswordClick(op2, $event)" class="mybtn">
            {{ 'label.ResetPassword' | translate }}
          </button>
        </div>
        <br />
        <div><img height="30" [src]="jobseeker?.logoFileName" /></div>
        <br />
        <div *ngIf="hasInternalEmployeeManagePermission">
          <button
            class="btn btn-primary"
            (click)="onFlagUnflagInternalEmployee()"
          >
            {{
              (jobseeker?.isInternalEmployee
                ? 'UnflagAsEmployee'
                : 'FlagAsEmployee'
              ) | translate
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="jobseeker-name">
  <div [hidden]="field?.fullName?.isInEditMode" class="jobseeker-name">
    <div>
      <div class="view-name">
        <!--@if (Model.IsFullNamePenging)
          {
              <span class="fa fa-exclamation-circle in-moderation" title="@Resources.Message.IsInModeration"></span>
          }-->
        {{ jobseeker?.name }} {{ jobseeker?.surname }}
      </div>
    </div>
    <div class="name-edit-button">
      <button
        [hidden]="field?.fullName?.hasValue"
        class="fa fa-plus-circle btn btn-link"
        (click)="onFullNameEditClik()"
        [disabled]="isInEditMode"
      ></button>
      <button
        [hidden]="!field?.fullName?.hasValue"
        class="fa fa-pencil btn btn-link"
        (click)="onFullNameEditClik()"
        [disabled]="isInEditMode"
      ></button>
    </div>
  </div>

  <div [hidden]="!field?.fullName?.isInEditMode" class="jobseeker-name">
    <div>
      <input
        type="text"
        [ngModel]="jobseeker && jobseeker.name"
        (ngModelChange)="jobseeker && (jobseeker.name = $event)"
      />
      <!--<cd-field-state data-name='Name'></cd-field-state>-->
      <hr-field-state-marker [field]="field?.name"></hr-field-state-marker>
    </div>
    <div>
      <input
        type="text"
        [ngModel]="jobseeker && jobseeker.surname"
        (ngModelChange)="jobseeker && (jobseeker.surname = $event)"
      />
      <!--<cd-field-state data-name='Surname'></cd-field-state>-->
      <hr-field-state-marker [field]="field?.surname"></hr-field-state-marker>
    </div>
    <div>
      <button class="btn btn-default" (click)="onFullNameSaveClick()">
        {{ 'label.Save' | translate }}
      </button>
      <button class="btn btn-default" (click)="onFullNameEditCancelClick()">
        {{ 'label.Cancel' | translate }}
      </button>
    </div>
  </div>
</div>
<div class="phone-email">
  <div class="jobseeker-phone">
    <div>{{ 'label.Phone' | translate }}:</div>
    <div [hidden]="field?.phone?.isInEditMode">
      <!--@if (Model.IsPhoneNumberPending)
            {
            <span class="fa fa-exclamation-circle in-moderation" title="@Resources.Message.IsInModeration"></span>
        }-->
      {{ jobseeker?.phone
      }}<span *ngIf="jobseeker?.phone != null && jobseeker?.phone2 != null"
        >,</span
      >
      {{ jobseeker?.phone2 }}
      <button
        [hidden]="field?.phone?.hasValue"
        class="fa fa-plus-circle btn btn-link"
        (click)="onPhoneEditClick()"
        [disabled]="isInEditMode"
      ></button>
      <button
        [hidden]="!field?.phone?.hasValue"
        class="fa fa-pencil btn btn-link"
        (click)="onPhoneEditClick()"
        [disabled]="isInEditMode"
      ></button>
    </div>
    <div [hidden]="!field?.phone?.isInEditMode" class="edit-mode">
      <div>
        <input
          type="text"
          [ngModel]="jobseeker && jobseeker.phone"
          (ngModelChange)="jobseeker && (jobseeker.phone = $event)"
        />
        <hr-field-state-marker [field]="field?.phone1"></hr-field-state-marker>
      </div>
      <div>
        <input
          type="text"
          [ngModel]="jobseeker && jobseeker.phone2"
          (ngModelChange)="jobseeker && (jobseeker.phone2 = $event)"
        />
        <hr-field-state-marker [field]="field?.phone2"></hr-field-state-marker>
      </div>
      <div class="buttons">
        <button class="btn btn-default" (click)="onPhoneSaveClick()">
          {{ 'label.Save' | translate }}
        </button>
        <button class="btn btn-default" (click)="onPhoneEditCancelClick()">
          {{ 'label.Cancel' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="jobseeker-email">
    <div>{{ 'label.Email' | translate }}:</div>
    <div [hidden]="field?.email?.isInEditMode">
      <!--@if (Model.IsEmailPending)
            {
            <span class="fa fa-exclamation-circle in-moderation" title="@Resources.Message.IsInModeration"></span>
        }-->
      {{ jobseeker?.email }}
      <button
        class="fa fa-pencil btn btn-link"
        (click)="onEmailEditClick()"
        [disabled]="isInEditMode"
      ></button>
    </div>
    <div [hidden]="!field?.email.isInEditMode" class="edit-mode">
      <input
        type="text"
        [ngModel]="jobseeker && jobseeker.email"
        (ngModelChange)="jobseeker && (jobseeker.email = $event)"
      />
      <button class="btn btn-default" (click)="onEmailSaveClick()">
        {{ 'label.Save' | translate }}
      </button>
      <button class="btn btn-default" (click)="onEmailEditCancelClick()">
        {{ 'label.Cancel' | translate }}
      </button>
      <hr-field-state-marker [field]="field?.email"></hr-field-state-marker>
    </div>
  </div>
</div>

<p-overlayPanel #op2 (onBeforeHide)="clearPassword($event)">{{
  resetPassword
}}</p-overlayPanel>
